import React from 'react'
import tw from 'tailwind-styled-components'
import {Lang} from 'yougile-lang'
import {ActionTypeFilter} from 'yougile-model'
import {
  DropdownMultiSelectList,
  getMultiSelectText,
  Option
} from '@components/common/dropdown-list/dropdown-list'
import {Remove} from '@components/statistics/stats-reports/common'

interface OuterProps {
  filter: ActionTypeFilter[]
  showRemoveButton?: boolean
  onOpenChange?: (isOpen: boolean) => void
  placeholder?: string
  withInputDecryption?: boolean
  classNameWidth?: string
  withoutProjectAndCompany?: boolean
}

interface Props extends OuterProps {
  update: (filters: ActionTypeFilter[]) => void
}

const getOptions = (
  withoutProjectAndCompany: boolean
): Option<ActionTypeFilter>[] => {
  const basic = [
    {value: 'add', label: Lang.msg.statsTimeline.statActionAdding},
    {value: 'delete', label: Lang.msg.statsTimeline.statActionDeleting},
    {value: 'restore', label: Lang.msg.statsTimeline.statActionRecovery},
    {value: 'rename', label: Lang.msg.statsTimeline.statActionRenaming},
    {value: 'move', label: Lang.msg.statsTimeline.statActionMoving},
    {
      value: 'complete',
      label: Lang.msg.statsTimeline.statActionArchiving
    },
    {
      value: 'uncomplete',
      label: Lang.msg.statsTimeline.statActionUnzipping
    },
    {value: 'done', label: Lang.msg.statsTimeline.statActionDone},
    {value: 'undone', label: Lang.msg.statsTimeline.statActionUnDone},

    {value: 'timer', label: Lang.msg.statsTimeline.statActionTimer},
    {
      value: 'timetracking',
      label: Lang.msg.statsTimeline.statActionTimetracker
    },
    {value: 'stopwatch', label: Lang.msg.statsTimeline.statActionStopwatch},

    {value: 'string', label: Lang.msg.statsTimeline.statActionString},
    {value: 'sprint', label: Lang.msg.statsTimeline.statActionSprint},
    {value: 'numeric', label: Lang.msg.statsTimeline.statActionNumeric},
    {value: 'text', label: Lang.msg.statsTimeline.statActionText},
    {value: 'executor', label: Lang.msg.statsTimeline.statActionExecutor},
    {value: 'deadline', label: Lang.msg.statsTimeline.statActionDeadline},
    {
      value: 'deadlineFailed',
      label: Lang.msg.statsTimeline.statActionDeadlineFailed
    },
    {value: 'file', label: Lang.msg.statsTimeline.statActionFiles}
  ]
  if (withoutProjectAndCompany) {
    return basic
  } else {
    return [
      ...basic,
      {value: 'message', label: Lang.msg.statsTimeline.statActionMessage},
      {
        value: 'add-user-to-project',
        label: Lang.msg.statsTimeline.statActionAddingUserToProject
      },
      {
        value: 'remove-user-from-project',
        label: Lang.msg.statsTimeline.statActionRemovingUserFromProject
      },
      {
        value: 'change-project-roles',
        label: Lang.msg.statsTimeline.statActionChangingRoles
      },
      {
        value: 'change-project-permissions',
        label: Lang.msg.statsTimeline.statActionChangePermissions
      },
      {
        value: 'add-user',
        label: Lang.msg.statsTimeline.statActionAddUser
      },
      {
        value: 'delete-user',
        label: Lang.msg.statsTimeline.statActionRemoveUser
      }
    ]
  }
}

export const ActionFilter = (props: Props) => {
  const {withoutProjectAndCompany = false} = props
  const options = getOptions(withoutProjectAndCompany)
  const {
    filter = options.map(x => x.value),
    update,
    showRemoveButton = true,
    onOpenChange,
    placeholder,
    withInputDecryption = false,
    classNameWidth
  } = props

  return (
    <div className="flex justify-between">
      <div className="flex">
        <DropdownMultiSelectList
          initialOpen={!props.filter}
          className={classNameWidth ?? 'w-160'}
          onChange={places => update(places)}
          value={filter}
          options={options}
          onOpenChange={isOpen => {
            if (typeof onOpenChange === 'function') {
              onOpenChange(isOpen)
            }
          }}
          placeholder={placeholder}
        />
      </div>
      {withInputDecryption && <ActionFilterLabels {...props} />}
      {showRemoveButton && <Remove update={() => update([])} />}
    </div>
  )
}

export const ActionFilterValue = (props: OuterProps) => {
  const {withoutProjectAndCompany = false} = props
  const options = getOptions(withoutProjectAndCompany)
  const {
    filter = options.map(x => x.value),
    placeholder = Lang.msg.statsTimeline.allActions
  } = props

  return <>{getMultiSelectText({value: filter, options, placeholder})}</>
}

const TwLabels = tw.div`
  flex-1
  w-8
  ml-16
  truncate
  text-third-old
  text-12
  self-center
`

const ActionFilterLabels = (props: OuterProps) => {
  const {withoutProjectAndCompany = false} = props
  const options = getOptions(withoutProjectAndCompany)
  const {filter = options.map(x => x.value)} = props
  const labels = options
    .filter(x => filter.includes(x.value))
    .map(x => x.label)
    .join(', ')

  return (
    filter.length !== options.length && (
      <TwLabels title={labels}>{labels}</TwLabels>
    )
  )
}
